<span class="loadingSnackbar">
  <div class="snackbarContent">
    <div class="throbber"></div>
    <p>{{ message }}</p>
  </div>
</span>
